import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ImageCarousel } from '../components/ImageCarousel';
import { ServicesSection } from '../components/ServicesSection';
import { ProjectsSection } from '../components/ProjectsSection';
import { StatsSection } from '../components/StatsSection';
import { ContactSection } from '../components/ContactSection';
export function Home() {
  return <main data-id="element-221">
      <HeroSection data-id="element-222" />
      <AboutSection data-id="element-223" />
      <StatsSection data-id="element-224" />
      <ProjectsSection data-id="element-225" />
      <ServicesSection data-id="element-226" />
      <ImageCarousel data-id="element-227" />
      <ContactSection data-id="element-228" />
    </main>;
}